/* eslint-disable prefer-promise-reject-errors */

import Swal from "sweetalert2";
import http from "./http-client";
import { appLogout } from "store/auth-context";

const API_URL = process.env.REACT_APP_API_URL;
async function client(endpoint, payload) {
  const { data, headers, config, ...customConfig } = payload || {};

  const onSuccess = async (response) => {
    const licenseWarning = response.headers["x-license-warning"];
    if (!licenseWarning) {
      appLogout();
      return Promise.reject({ message: "Please re-authenticate." });
    } else if (licenseWarning === "Valid") {
      const event = new CustomEvent("licenseWarning", {
        detail: { message: "" },
      });
      window.dispatchEvent(event);
    } else {
      const event = new CustomEvent("licenseWarning", {
        detail: { message: licenseWarning },
      });
      window.dispatchEvent(event);
    }
    if (response.status === 200) {
      if (
        customConfig?.successMessage &&
        response?.data &&
        typeof response?.data === "string"
      ) {
        Swal.fire({
          icon: "warning",
          title: `<span style="font-size:1.5rem">Following request(s) failed.</span>`,
          html: `<ul style="text-align: left; list-style:auto; padding: 0 0 0 1.6em"><li>${response?.data?.replaceAll(",", "</li><li>")}</li></ul>`,
        });
      } else if (customConfig?.successMessage) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: customConfig?.successMessage,
        });
      }
      return response;
    }
    return Promise.reject({ message: data?.message || response?.title });
  };

  const onFail = (error) => {
    if (error.status === 409) {
      Swal.fire({
        icon: "error",
        title: `Error ${error.status}`,
        text: "The resource you are trying to add is already exist.",
      });
      return Promise.reject({
        message: error?.message || error?.title,
        status: error.status,
      });
    }

    if (error.status === 403) {
      Swal.fire({
        icon: "error",
        title: `Error ${error.status}`,
        text: "You are not authorized to access this resource. kindly contact support.",
      });
      return Promise.reject({
        message: error?.message || error?.title,
        status: error.status,
      });
    }

    if (error.status === 404) {
      return Promise.reject({
        message: data?.message || error?.message || error?.title,
        status: error.status,
      });
    }

    if (error.status === 400) {
      if (error?.response?.data && typeof error?.response?.data === "string") {
        Swal.fire({
          icon: "warning",
          title: `<span style="font-size:1.5rem">Following request(s) failed.</span>`,
          html: `<ul style="text-align: left; list-style:auto; padding: 0 0 0 1.6em"><li>${error?.response?.data?.replaceAll(",", "</li><li>")}</li></ul>`,
        });
      } else {
        let errorMessage = "";

        if (error?.response?.data?.errors) {
          errorMessage = Object.values(error?.response?.data?.errors)
            ?.map((i) => i.join(","))
            ?.join(",");
        } else if (error?.response?.data) {
          errorMessage = error?.response?.data
            ?.map((item) => item?.description)
            ?.join(",");
        }

        Swal.fire({
          icon: "error",
          title: `Error ${error.status}`,
          html: errorMessage
            ? `<ul style="text-align: left; list-style:auto; padding: 0 0 0 1.6em"><li>${errorMessage?.replaceAll(",", "</li><li>")}</li></ul>`
            : error?.message,
        });
      }

      return Promise.reject({
        message: error?.message,
        status: error.status,
      });
    }

    Swal.fire({
      icon: "error",
      title: `Error ${error.status}`,
      text: "Something went wrong please try again.",
    });
    return Promise.reject({
      message: error?.message || error?.title,
      status: error.status,
    });
  };

  if (customConfig.method === "delete") {
    return http
      .delete(`${API_URL}/${endpoint}`, data || {}, config || {})
      .then(onSuccess)
      .catch(onFail);
  } else if (customConfig.method === "put") {
    return http
      .put(`${API_URL}/${endpoint}`, data, config || {})
      .then(onSuccess)
      .catch(onFail);
  } else if (data || customConfig.method === "post") {
    return http
      .post(
        `${API_URL}/${endpoint}`,
        data,
        headers ? { headers: { ...headers } } : {},
        config || {},
      )

      .then(onSuccess)
      .catch(onFail);
  }
  return http
    .get(`${API_URL}/${endpoint}`, config || {})
    .then(onSuccess)
    .catch(onFail);
}

export { client };
